import { createTheme } from '@mui/material/styles'

// MUI reads its theme from the same emotion context the app uses for its
// white-label client theme (primaryColor, lightestGray, ...). That flat theme
// has none of the keys MUI expects (palette, transitions, ...), so MUI
// components must run under their own theme. We resolve the client's brand
// colors from the emotion theme in each component, then hand MUI this default
// theme via `<ThemeProvider theme={muiTheme}>`. MUI merges against its own
// (empty) private-theming context rather than the app's emotion theme, so the
// flat client theme and MUI's theme never collide.

/**
 * Alert colors, taken from the institutional portal so status messaging reads the same across
 * both products.
 *
 * These are status colors rather than brand colors, so they are fixed here instead of being
 * resolved from the client's white-label theme — a success toast should not change color per
 * client. MUI's own filled palette is far more saturated than this, which is why every severity
 * is spelled out.
 */
const ALERT_COLORS = {
  success: { backgroundColor: '#b8d6a9', color: '#4f793a' },
  error: { backgroundColor: '#fbb6bf', color: '#ce0b24' },
  warning: { backgroundColor: '#fceecf', color: '#aa5009' },
  // The portal leaves info unstyled ("fill in if we ever use it"), so this follows the same
  // pattern with its neutral tokens rather than falling back to MUI's saturated blue.
  info: { backgroundColor: '#e6e9ea', color: '#022a3a' },
}

const muiTheme = createTheme({
  typography: {
    fontFamily: "'Open Sans', 'Helvetica Neue', sans-serif",
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        // The severity glyph and the dismiss button set no color of their own, so both pick up
        // the text color from here.
        root: ({ ownerState }) => ({
          ...ALERT_COLORS[ownerState.severity],
        }),
      },
    },
  },
})

export { ALERT_COLORS }
export default muiTheme
